module.exports = __webpack_public_path__ + "static/media/edit_calendar.9f8e9d9c.svg";